{
 "_doc": "review R10-016: the phone hotbar shows one whole word of a skill's name; these are the deliberate short labels, for skills where no word of the name fits five letters and for names whose first short word is filler (HAVE AT THEE showed HAVE, IT'S A HELM showed IT'S). ui.ts fitBelt shows this label first, then the name's own words, then breaks the word over two lines. Keyed by skill id; the full name is in the tooltip and the SKILLS tab. A label may be a list, best first (polish-hud, R5-007): a phone slot at LARGE or HUGE holds about four letters, so each playable skill whose word is longer ends with a four-letter (or shorter) real word; fitBelt takes the first that fits whole, and only then drops the name to the smallest legal size (13.5 px on a phone) before it gives up.",
 "labels": {
  "props_discipline": "SIT",
  "sean_shield_charge": "MOVE",
  "sean_the_dubbing": ["KNEEL", "SIR"],
  "steve_louder": ["NOISE", "LOUD"],
  "scott_barrel": "KEG",
  "scott_cannonball": "FIRE",
  "scott_broadside": "SALVO",
  "honey_catwalk": "STRUT",
  "honey_showtime": "SHOW",
  "moon_tantrum": "FIT",
  "rocco_the_whistle": "HEY",
  "rocco_no_running": "WALK",
  "shadia_premier_service": "SERVE",
  "seamus_rainbow": "ARC",
  "gull_skraaw": ["SKRAAW", "CAW"],
  "theomen_champions_clutch": "BELT",
  "kevin_double_feature": "DVD",
  "eljeffe_service": ["HANDS", "DISH"],
  "eljeffe_fajita_skillet": "PAN",
  "tash_blackout": "BINGO",
  "sean_have_at_thee": ["SWEEP", "HACK"],
  "sean_its_a_helm": "HELM",
  "moon_my_number_one": "NO.1",
  "todd_lay_one": "EGG",
  "todd_flown_the_coop": "COOP",
  "tim_on_the_house": "SHOTS",
  "tim_last_call": "CALL",
  "bambi_pool_noodle": "WHACK",
  "shadia_room_service": "BELL",
  "seamus_pot_of_gold": "GOLD",
  "theomen_bat_swarm": "BATS",
  "theomen_feel_the_chill": "CHILL",
  "theomen_blood_moon": "MOON",
  "kevin_late_fee": "FEE",
  "kevin_be_kind_rewind": "KIND",
  "shadow_rising_pour": "RISE",
  "eljeffe_hot_plate": ["PLATE", "HOT"],
  "eljeffe_eighty_six": "86",
  "tash_keep_it_down": "QUIET",
  "joe_bar_slide": "SLIDE",
  "joe_not_tonight": "NOPE",
  "joe_back_door": "OUT",
  "joe_the_black_dog": "AWOO",
  "steve_power_chord": ["POWER", "RIFF"],
  "props_sucker_punch": ["SUCKER", "PUNCH", "JAB"],
  "props_total_disrespect": ["TOTAL", "DISS"],
  "matt_shiko": ["NOTED", "NOTE"],
  "matt_dohyo": ["BOOTH", "ROPE"],
  "matt_shiddys_round": ["ROUND", "TAB"],
  "matt_purifying_salt": "SALT",
  "gull_the_stoop": ["STOOP", "SNAP"],
  "gull_the_flock": ["FLOCK", "MOB"]
 }
}
